import React, { useState } from "react";

const AccountDeletionRequest = () => {
  const [reason, setReason] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setResponseMessage("");

    if (!confirm) {
      return setError(
        "Please confirm that you understand account deletion is permanent.",
      );
    }

    //check if ether phone or email is provided
    if (!phone && !email) {
      return setError(
        "Please provide either your phone number or email address registered with your account for verification.",
      );
    }

    try {
      setLoading(true);

      //   const res = await fetch("/api/account/delete-request", {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${localStorage.getItem("token")}`,
      //     },
      //     body: JSON.stringify({
      //       reason,
      //       message,
      //       password,
      //     }),
      //   });

      //   const data = await res.json();

      //   if (!res.ok) {
      //     throw new Error(data.message || "Something went wrong");
      //   }
      //delay for 3 seconds to simulate API call
      await new Promise((resolve) => setTimeout(resolve, 3000));

      setResponseMessage(
        "Your account deletion request has been submitted successfully.",
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Request Account Deletion</h2>

        <p style={styles.warning}>
          ⚠️ This action is permanent. All your data in Tumwabudu Mungu Wetu
          will be deleted and cannot be recovered.
        </p>

        <form onSubmit={handleSubmit}>
          <label style={styles.label}>Reason for leaving</label>
          <select
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            style={styles.input}
            required
          >
            <option value="">Select a reason</option>
            <option value="privacy">Privacy concerns</option>
            <option value="not_useful">App not useful</option>
            <option value="technical">Technical problems</option>
            <option value="other">Other</option>
          </select>

          <label style={styles.label}>Phone Number</label>
          <input
            type="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={styles.input}
            placeholder="Enter your phone number"
          />

          <label style={styles.label}>Email Address</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            placeholder="Enter your email address"
          />

          <label style={styles.label}>Additional Message (Optional)</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={styles.textarea}
            placeholder="Tell us more..."
          />

          <div style={styles.checkboxContainer}>
            <input
              type="checkbox"
              checked={confirm}
              onChange={(e) => setConfirm(e.target.checked)}
            />
            <span style={{ marginLeft: 8 }}>
              I understand that this action is permanent.
            </span>
          </div>

          {error && <p style={styles.error}>{error}</p>}
          {responseMessage && <p style={styles.success}>{responseMessage}</p>}

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Submitting..." : "Submit Deletion Request"}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
  },
  card: {
    width: "100%",
    maxWidth: "500px",
    padding: "30px",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
  },
  title: {
    marginBottom: "15px",
    textAlign: "center",
    textWeight: "bold",
  },
  warning: {
    fontSize: "14px",
    color: "#c0392b",
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    marginTop: "15px",
    fontWeight: "500",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  textarea: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    minHeight: "80px",
  },
  checkboxContainer: {
    marginTop: "15px",
    display: "flex",
    alignItems: "center",
  },
  button: {
    width: "100%",
    padding: "12px",
    marginTop: "20px",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "#e74c3c",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer",
  },
  error: {
    color: "#e74c3c",
    marginTop: "10px",
  },
  success: {
    color: "#27ae60",
    marginTop: "10px",
  },
};

export default AccountDeletionRequest;
